// extracted by mini-css-extract-plugin
export var footer = "_nb-0";
export var inherit = "_nb-1";
export var input = "_nb-2";
export var modalContent = "_nb-3";
export var quillEditor = "_nb-4";
export var subtitle = "_nb-5";